import { render, staticRenderFns } from "./FacultySearch.vue?vue&type=template&id=5c449ce7"
import script from "./FacultySearch.vue?vue&type=script&lang=js"
export * from "./FacultySearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Projects\\MDA\\schoolofmusic-ucla\\web\\app\\themes\\ucla\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c449ce7')) {
      api.createRecord('5c449ce7', component.options)
    } else {
      api.reload('5c449ce7', component.options)
    }
    module.hot.accept("./FacultySearch.vue?vue&type=template&id=5c449ce7", function () {
      api.rerender('5c449ce7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/components/FacultySearch.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/components/FacultySearch.vue
// module id = 402
// module chunks = 0